import sum from './sum'

function average (numbers) {
  return sum(numbers) / numbers.length
}

export default average
